function isStringOfLength(str) {
    return typeof str === 'string' && str.length > 0;
}

function isCrewValid(crew) {
    if (!isStringOfLength(crew.AFSC) || !isStringOfLength(crew.CREW_POSITION)) {
        return false;
    }
    if (isNaN(crew.CREW_RATIO) || isNaN(crew.CREW_COMP_OFF) || isNaN(crew.CREW_COMP_ENL)) {
        return false;
    }
    if (crew.CREW_RATIO < 0) {
        return false;
    }
    if (crew.CREW_COMP_OFF === 0 && crew.CREW_COMP_ENL === 0) {
        return false;
    }
    if (!(typeof crew.FAC === 'string' && crew.FAC.length === 6)) {
        return false;
    }
    return true;
}
function getMissingFields(model) {
    const missingFields = [];

    if (!isStringOfLength(model.AFSC)) {
        missingFields.push('AFSC');
    }
    if (!isStringOfLength(model.CREW_POSITION)) {
        missingFields.push('Aircrew Position');
    }
    if (isNaN(model.CREW_RATIO)) {
        missingFields.push('Aircrew Ratio');
    }
    if (isNaN(model.CREW_COMP_OFF)) {
        missingFields.push('Crew Complement OFF');
    }
    if (isNaN(model.CREW_COMP_ENL)) {
        missingFields.push('Crew Complement ENL');
    }
    if (model.CREW_RATIO < 0) {
        missingFields.push('Aircrew Ratio');
    }
    if (!(typeof model.FAC === 'string' && model.FAC.length === 6)) {
        missingFields.push('FAC');
    }
    if (model.CREW_COMP_OFF === 0 && model.CREW_COMP_ENL === 0) {
        missingFields.push('Crew Complement OFF, Crew Complement ENL');
    }
    return missingFields;
}

export function validateUpdateModelFields(model) {
    let allMissingFields = [];
    const missingFieldsSet = new Set();

    if (typeof model.POC === 'string' && model.POC.length < 1) {
        allMissingFields.push('POC');
    }
    Object.entries(model).forEach(([key, value]) => {
        if (key === 'composition') {
            value.forEach((v) => {
                let missingFields = getMissingFields(v);
                allMissingFields = allMissingFields.concat(missingFields);
            });
        }
    });

    allMissingFields.forEach((field) => {
        missingFieldsSet.add(field);
    });

    return missingFieldsSet;
}

export function validateUpdateModelState(model) {
    return Object.entries(model).every(([key, value]) => {
        if (key === 'composition') {
            return value.every(isCrewValid);
        }
        if (typeof value === 'string') {
            if (key === 'NOTES') {
                // Notes can be empty
                return true;
            }
            return value.length > 0;
        }
        if (typeof value === 'number') {
            return true;
        }
        return true;
    });
}
